export const BUILD_VERSION = '1788870439';
